module.exports = __webpack_public_path__ + "static/media/ope_heli_770x770.eb1414ef.jpg";